export const getSetupTitle = (inProgress, partnerName) => {
    if (inProgress) {
        return 'Payouts set up in progress...';
    }
    if (partnerName) {
        return `At the start of each month we will transfer your earnings to the connected bank account managed by ${partnerName}.`;
    }
    return 'At the start of each month we will transfer your earnings to the connected bank account.';
};
